import { render, staticRenderFns } from "./RegulatoryUpdateTemplate.vue?vue&type=template&id=2ca7f347&scoped=true"
import script from "./RegulatoryUpdateTemplate.vue?vue&type=script&lang=ts"
export * from "./RegulatoryUpdateTemplate.vue?vue&type=script&lang=ts"
import style0 from "./RegulatoryUpdateTemplate.vue?vue&type=style&index=0&id=2ca7f347&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca7f347",
  null
  
)

export default component.exports